/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function PlusRoundedSolid({
    className = null,
}: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
            <g clipPath="url(#clip0_1356_72)">
                <path d="M6.5 0C5.31331 0 4.15328 0.351894 3.16658 1.01118C2.17989 1.67047 1.41085 2.60754 0.956725 3.7039C0.5026 4.80025 0.38378 6.00665 0.615291 7.17054C0.846802 8.33443 1.41825 9.40352 2.25736 10.2426C3.09648 11.0818 4.16557 11.6532 5.32946 11.8847C6.49335 12.1162 7.69974 11.9974 8.7961 11.5433C9.89246 11.0891 10.8295 10.3201 11.4888 9.33342C12.1481 8.34672 12.5 7.18669 12.5 6C12.4982 4.40926 11.8654 2.88421 10.7406 1.75939C9.61579 0.63457 8.09074 0.00183871 6.5 0ZM9.17916 6.63158H7.13158V8.67916C7.13158 8.84666 7.06504 9.0073 6.94659 9.12575C6.82815 9.24419 6.66751 9.31073 6.5 9.31073C6.3325 9.31073 6.17185 9.24419 6.05341 9.12575C5.93496 9.0073 5.86842 8.84666 5.86842 8.67916V6.63158H3.82084C3.65334 6.63158 3.49269 6.56504 3.37425 6.44659C3.25581 6.32815 3.18927 6.1675 3.18927 6C3.18927 5.83249 3.25581 5.67185 3.37425 5.5534C3.49269 5.43496 3.65334 5.36842 3.82084 5.36842H5.86842V3.32084C5.86842 3.15334 5.93496 2.99269 6.05341 2.87425C6.17185 2.7558 6.3325 2.68926 6.5 2.68926C6.66751 2.68926 6.82815 2.7558 6.94659 2.87425C7.06504 2.99269 7.13158 3.15334 7.13158 3.32084V5.36842H9.17916C9.34666 5.36842 9.50731 5.43496 9.62575 5.5534C9.7442 5.67185 9.81074 5.83249 9.81074 6C9.81074 6.1675 9.7442 6.32815 9.62575 6.44659C9.50731 6.56504 9.34666 6.63158 9.17916 6.63158Z" fill="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_1356_72">
                    <rect width="12" height="12" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
